// extracted by mini-css-extract-plugin
export default {"logoTextBanner":"EO3dkXIGW6MmCok9pgM2","logo":"dt0ihcpOJLsaEQ0r2u7l","content":"sL3ctlnkCKmX148Z9QEk"};